import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { PrimeReactProvider } from 'primereact/api';
import { BlockUI } from 'primereact/blockui';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';

import './App.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';

import "primereact/resources/themes/lara-dark-blue/theme.css"

import useWebSocket from 'react-use-websocket';

import TV from "./pages/TV";
import Admin from "./pages/Admin";
import Login from "./pages/Login";

import axios from './axios';

const WS_URL = (window.location.protocol === "http:" ? "ws:" : "wss:") + "//" + window.location.hostname + process.env.REACT_APP_WEBSOCKET_APPENDIX;

const App = () => {
	const value = {
		ripple: true,
	};
	const toast = useRef(null);
	const [blocked, setBlocked] = useState(false);
	const [editorBlocked, setEditorBlocked] = useState(false);
	const [callersBlocked, setCallersBlocked] = useState(false);
	const [loginBlocked, setLoginBlocked] = useState(true);
	const [notification, setNotification] = useState("")
	const didUnmount = useRef(false);

	useEffect(() => {
		setBlocked(true)
		return () => {
			didUnmount.current = true;
		};
	}, [])

	const { sendMessage, lastMessage, readyState } = useWebSocket(WS_URL, {
		onOpen: () => {
			setBlocked(false)
		},
		onClose: () => {
			setBlocked(true)
		},
		onMessage: (event) => {
			setNotification(JSON.parse(event.data))
		},
		shouldReconnect: () => {
			return didUnmount.current === false;
		},
		reconnectAttempts: 30,
		reconnectInterval: 3000,
	});

	const [login, setLogin] = useState(false);

	useEffect(() => {
		const authenticate = async () => {
			try {
				const response = await axios.post('/authenticate');
				if (response.data.success) {
					setLogin(true)
					setLoginBlocked(false)
				}
			} catch (error) {
				setLoginBlocked(false)
			}
		};

		authenticate();
	}, [])

	return (
		<PrimeReactProvider value={value}>
			<BlockUI blocked={blocked || callersBlocked || editorBlocked || loginBlocked} fullScreen template={<ProgressSpinner />} />
			<Toast ref={toast} />
			<Router basename={process.env.REACT_APP_SUBFOLDER}>
				<Routes>
					{loginBlocked == true ? (
						<></>
					) : login == false ? (
						<Route path="*">
							<Route path="login" element={<Login toast={toast} setBlocked={setBlocked} setLogin={setLogin}/>} />

							<Route path="*" element={<Navigate to="/login" />} />
						</Route>
					) : (
						<Route path="*">
							<Route path="admin" element={<Admin toast={toast} setCallersBlocked={setCallersBlocked} setEditorBlocked={setEditorBlocked} sendMessage={sendMessage} notification={notification} setNotification={setNotification}/>} />
							<Route path="tv" element={<TV toast={toast} setCallersBlocked={setCallersBlocked} setEditorBlocked={setEditorBlocked} sendMessage={sendMessage} notification={notification} setNotification={setNotification}/>} />

							<Route path="*" element={<Navigate to="/admin" />} />
						</Route>
					)}
				</Routes>
			</Router>
		</PrimeReactProvider>
	);
}

/*
<Splitter style={{ width: '100%', height: '100%' }} layout="vertical">
				<SplitterPanel className="flex flex-column overflow-hidden" size={20} minSize={0}>
					<CallersTable setBlocked={setCallersBlocked} toast={toast} sendMessage={sendMessage} notification={notification} />
				</SplitterPanel>
				<SplitterPanel className="flex flex-column" size={80} minSize={0}>
					<Splitter layout="vertical">
						<SplitterPanel className="flex flex-column relative" size={90} minSize={20}>
							<TextEditor setBlocked={setEditorBlocked} toast={toast} sendMessage={sendMessage} notification={notification} />
						</SplitterPanel>
						<SplitterPanel className="flex flex-row p-3 gap-5 align-items-center justify-content-end" size={10} minSize={0}>
							<BottomBar sendMessage={sendMessage} notification={notification} setNotification={setNotification}/>
						</SplitterPanel>
					</Splitter>
				</SplitterPanel>
			</Splitter>
*/

export default App;
